import React, { useState, useEffect } from 'react';
import './styles/global.css';
import LoginPage     from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import DishesPage    from './pages/DishesPage';
import OrdersPage    from './pages/OrdersPage';
import ReviewsPage   from './pages/ReviewsPage'; // Підключили сторінку відгуків

const NAV = [
  // { id: 'dashboard', label: 'Дашборд',    icon: '📊' }, // Тимчасово приховано
  { id: 'dishes',    label: 'Страви',     icon: '🍽' },
  // { id: 'orders',    label: 'Замовлення', icon: '🧾' }, // Тимчасово приховано
  { id: 'reviews',   label: 'Відгуки',    icon: '⭐' }, 
];

// Хук для визначення мобільного пристрою
function useIsMobile() {
  const [v, setV] = useState(window.innerWidth < 768);
  useEffect(() => {
    const fn = () => setV(window.innerWidth < 768);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);
  return v;
}

export default function App() {
  const [user, setUser] = useState(null);
  const [page, setPage] = useState('dishes'); // ЗМІНЕНО: тепер стартова сторінка - "Страви"
  
  // Додаємо стани для мобільного меню
  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    // Перевіряємо токен з основного сайту
    // Читаємо токен з URL
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get('token');
    const urlUser = params.get('user');
    if (urlToken && urlUser) {
        localStorage.setItem('admin_token', urlToken);
        localStorage.setItem('admin_user', decodeURIComponent(urlUser));
        window.history.replaceState({}, '', '/');
    }
    const siteToken = localStorage.getItem('token');
    const siteUser  = localStorage.getItem('user');
    if (siteToken && siteUser) {
      const parsed = JSON.parse(siteUser);
      if (parsed.role === 'admin') {
        localStorage.setItem('admin_token', siteToken);
        localStorage.setItem('admin_user', siteUser);
        setUser(parsed);
        return;
      }
    }
    // Перевіряємо адмін storage
    const adminToken = localStorage.getItem('admin_token');
    const adminUser  = localStorage.getItem('admin_user');
    if (adminToken && adminUser) {
      setUser(JSON.parse(adminUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    setUser(null);
  };

  if (!user) return <LoginPage onLogin={setUser} />;

  const renderPage = () => {
    if (page === 'dashboard') return <DashboardPage />;
    if (page === 'dishes')    return <DishesPage />;
    if (page === 'orders')    return <OrdersPage />;
    if (page === 'reviews')   return <ReviewsPage />; 
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: 'var(--paper)', position: 'relative' }}>
      
      {/* 1. БОКОВЕ МЕНЮ */}
      <aside style={{
        width: 220, background: 'var(--ink)',
        display: 'flex', flexDirection: 'column',
        padding: '24px 0', flexShrink: 0,
        /* Адаптивні стилі для мобілки */
        position: isMobile ? 'fixed' : 'relative',
        zIndex: 100,
        height: '100%',
        transition: 'transform 0.3s ease',
        transform: isMobile && !menuOpen ? 'translateX(-100%)' : 'translateX(0)',
      }}>
        <div style={{ padding: '0 20px 20px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 36, height: 36, background: 'var(--highlight)', borderRadius: 9,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontFamily: "'Fraunces', serif", fontSize: 16, color: 'var(--ink)',
            }}>R</div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 500, color: '#fff' }}>Адмін панель</div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', fontWeight: 300 }}>Ресторан «Околиця»</div>
            </div>
          </div>
        </div>

        <nav style={{ flex: 1, padding: '16px 12px', display: 'flex', flexDirection: 'column', gap: 4 }}>
          {NAV.map(item => (
            <button 
              key={item.id} 
              onClick={() => { 
                setPage(item.id); 
                if (isMobile) setMenuOpen(false); // Закриваємо меню після кліку на телефоні
              }} 
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '10px 12px', borderRadius: 10, border: 'none',
                background: page === item.id ? 'rgba(255,255,255,0.12)' : 'transparent',
                color: page === item.id ? '#fff' : 'rgba(255,255,255,0.45)',
                fontSize: 13, fontWeight: page === item.id ? 500 : 400,
                textAlign: 'left', transition: 'all 0.15s', cursor: 'pointer',
              }}
              onMouseEnter={e => { if (page !== item.id) e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; }}
              onMouseLeave={e => { if (page !== item.id) e.currentTarget.style.background = 'transparent'; }}
            >
              <span style={{ fontSize: 16 }}>{item.icon}</span>
              {item.label}
            </button>
          ))}

          {/* Повернутись на сайт */}
          <div style={{ marginTop: 8, paddingTop: 8, borderTop: '1px solid rgba(255,255,255,0.08)' }}>
            <button
              // ОНОВЛЕНО: Тепер кнопка веде на ваш власний куплений домен
              onClick={() => window.open('https://okolitsya-lentochka.com.ua', '_blank')}
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '10px 12px', borderRadius: 10, border: 'none',
                background: 'transparent', color: 'rgba(255,255,255,0.45)',
                fontSize: 13, textAlign: 'left', transition: 'all 0.15s',
                cursor: 'pointer', width: '100%',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(232,201,126,0.15)'; e.currentTarget.style.color = '#e8c97e'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'rgba(255,255,255,0.45)'; }}
            >
              <span style={{ fontSize: 16 }}>🌐</span>
              Повернутись на сайт
            </button>
          </div>
        </nav>

        <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginBottom: 2, fontWeight: 300 }}>
            {user.email}
          </div>
          <button onClick={handleLogout} style={{
            marginTop: 8, padding: '7px 14px', borderRadius: 8,
            border: '1px solid rgba(255,255,255,0.15)', background: 'transparent',
            color: 'rgba(255,255,255,0.5)', fontSize: 12, cursor: 'pointer',
            transition: 'all 0.15s',
          }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)'; e.currentTarget.style.color = '#fff'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)'; e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; }}
          >
            Вийти
          </button>
        </div>
      </aside>

      {/* 2. ТІНЬ для телефону */}
      {isMobile && menuOpen && (
        <div 
          onClick={() => setMenuOpen(false)} 
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 90 }} 
        />
      )}

      {/* 3. ОСНОВНИЙ КОНТЕНТ */}
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', width: '100%' }}>
        
        {/* Верхня смужка з гамбургером ТІЛЬКИ на телефоні */}
        {isMobile && (
          <div style={{ padding: '12px 16px', background: '#fff', borderBottom: '1px solid #ddd5c8', display: 'flex', alignItems: 'center' }}>
            <button 
              onClick={() => setMenuOpen(true)} 
              style={{ background: 'transparent', border: 'none', fontSize: 24, cursor: 'pointer', padding: 0, marginRight: 16, color: 'var(--ink)' }}
            >
              ☰
            </button>
            <span style={{ fontSize: 18, fontWeight: 500, fontFamily: "'Fraunces', serif", color: 'var(--ink)' }}>
              {NAV.find(n => n.id === page)?.label || 'Адмін-панель'}
            </span>
          </div>
        )}

        <div style={{ flex: 1, overflowY: 'auto', padding: isMobile ? '16px 12px' : '32px' }}>
          {renderPage()}
        </div>
      </main>

    </div>
  );
}
